import { useEffect } from "react";
import HelpJiraButton from "../../assets/svg/HelpJiraButton";
import useMobile from "../../utils/helpers/useMobile";

function JiraWidget() {
  const isMobile = useMobile()
  function handleOpen() {
    const iframe: any = document.getElementById("jsd-widget");
    
    if (!iframe) return;

    try {
      // Access the iframe's document
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      
      if (!iframeDoc) return;

      // Perform actions, e.g., clicking a button inside the iframe
      const button = iframeDoc.querySelector("#help-button");
      if (button) {
        button.style = "display:block;"
        button?.click();
      }
    } catch (error) {
      // Cross-origin or not accessible
      console.warn("Could not access Jira widget iframe:", error);
    }
  }

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    
    const hideButton = () => {
      const iframe: any = document.getElementById("jsd-widget");
      
      // Check if iframe exists
      if (!iframe) return;
      
      try {
        // Access the iframe's document
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        
        if (!iframeDoc) return;

        // Perform actions, e.g., clicking a button inside the iframe
        const button: any = iframeDoc.querySelector("#help-button");
        if (button) {
          button.style = "display:none; z-index:0;"
          // Stop interval once button is found and hidden
          if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }
        }
      } catch (error) {
        // Cross-origin or not loaded yet - ignore
        return;
      }
    }
    
    // Wait for iframe to be created
    const waitForIframe = () => {
      const iframe: any = document.getElementById("jsd-widget");
      if (iframe) {
        // Iframe exists, try to hide button
        hideButton();
        
        // Set up interval to keep trying (in case content loads later)
        if (!intervalId) {
          intervalId = setInterval(hideButton, 100);
        }
        
        // Also listen for load event
        iframe.addEventListener('load', hideButton, { once: true });
      }
    };
    
    // Initial check
    waitForIframe();
    
    // Check periodically in case script loads later
    const checkInterval = setInterval(waitForIframe, 500);
    
    // Also watch for DOM changes
    const observer = new MutationObserver(waitForIframe);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (intervalId) clearInterval(intervalId);
      clearInterval(checkInterval);
      observer.disconnect();
    }
  }, [])


  return <button type="button" onClick={handleOpen} className="JiraWidget">{isMobile ? <HelpJiraButton/>:<span>Help</span>}</button>;
}

export default JiraWidget;


// import { useEffect } from "react";

// function JiraWidget() {
//   function handleOpen() {
//     const iframe: any = document.getElementById("jsd-widget");

//     // Access the iframe's document
//     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;


//     // Perform actions, e.g., clicking a button inside the iframe
//     const button = iframeDoc.querySelector("#help-button");
//     button.style = "display:block;"
//     button?.click();
//   }

// useEffect(() => {
//   const iframe: any = document.getElementById("jsd-widget");
//   if (!iframe) return;

//   const hideButton = () => {
//     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
//     const button: any = iframeDoc?.querySelector("#help-button");
//     if (button) {
//       button.style.display = "none";
//       button.style.zIndex = "0";
//     }
//   };

//   const observer = new MutationObserver(hideButton);

//   iframe.addEventListener("load", () => {
//     const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
//     if (iframeDoc) {
//       observer.observe(iframeDoc.body, {
//         childList: true,
//         subtree: true,
//       });
//       hideButton(); // initial attempt
//     }
//   });

//   return () => {
//     observer.disconnect();
//   };
// }, []);



//   return <button type="button" onClick={handleOpen} className="JiraWidget" >Help</button>;
// }

// export default JiraWidget;
